import { EVENT_BUS_EVENT } from './enums/event-bus-events';

export default class EventBus {
  private static instance: EventBus;
  private bus: Comment | undefined = undefined;

  constructor() {
    if (!EventBus.instance) {
      this.bus = document.createComment('event-bus');
      EventBus.instance = this;
      return EventBus.instance;
    }
    return EventBus.instance;
  }

  static getInstance = () => {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus();
      return EventBus.instance;
    }
    return EventBus.instance;
  };

  dispatch = (eventName: EVENT_BUS_EVENT, eventProps?: any) => {
    this?.bus?.dispatchEvent(new CustomEvent(eventName, { detail: eventProps }));
  };

  addListener = (eventName: EVENT_BUS_EVENT, listener: () => void) => {
    this?.bus?.addEventListener(eventName, listener);
  };

  removeListener = (eventName: EVENT_BUS_EVENT, listener: () => void) => {
    this?.bus?.removeEventListener(eventName, listener);
  };
}

